export const PLACEHOLDERS = {
    LOGO: "{{logo}}",
    BOLD_START: "[[",
    BOLD_END: "]]",
    INLINE_IMG_START: "{{img|",
    INLINE_IMG_END: "}}",
    BS_HEADER_UNICODE: "{{title_unicode}}",
    BS_TITLE_SVG_VAL: "{{svg_value}}",
    OPEN: "[[[",
    CLOSE: "]]]",
    EMOJI_OPEN: "[{",
    EMOJI_CLOSE: "}]",
    BASE_PRICE: "{{base_price}}",
    ANIMATE_IDENTIFIER: "{{animate}}",
    TYPOGRAPHY_START: "[{{typography|",
    TYPOGRAPHY_END: "}}]",
    BR_TAG: "<br/>",
};
